import { render, staticRenderFns } from "./WhatsappAssociacoes.vue?vue&type=template&id=9a4241c0&scoped=true"
import script from "./WhatsappAssociacoes.vue?vue&type=script&lang=js"
export * from "./WhatsappAssociacoes.vue?vue&type=script&lang=js"
import style0 from "./WhatsappAssociacoes.vue?vue&type=style&index=0&id=9a4241c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4241c0",
  null
  
)

export default component.exports